export default "__VITE_ASSET__Clr3$Nn1__"